import { AxiosResponse } from "axios";

import {
  IEMedIntegrationCount,
  IEMedPatientLabResults,
  IEMedPatientMedications,
} from "../../@types/admin/AdminEMedIntegration";
import { api } from "../api";

/**
 * eMED Beaumont integration admin page (EN-5160), migrated from the Retool
 * EMedBeaumontIntegration app. Read-only: what the HL7 feed delivered, by
 * date and process.
 */
export const eMedIntegrationService = {
  /** Message counts grouped by date, hospital and process name. */
  async getIntegrationCounts(): Promise<
    AxiosResponse<IEMedIntegrationCount[]>
  > {
    return api.get<IEMedIntegrationCount[]>(
      "/Retool/EMedIntegration/GetIntegrationCountByDate"
    );
  },

  /** Lab-result messages queued on one date. */
  async getPatientLabResultsByDate(
    date: string
  ): Promise<AxiosResponse<IEMedPatientLabResults[]>> {
    return api.get<IEMedPatientLabResults[]>(
      "/Retool/EMedIntegration/PatientLabResultsByDate",
      { params: { date } }
    );
  },

  /** Medication messages queued on one date. */
  async getPatientMedicationsByDate(
    date: string
  ): Promise<AxiosResponse<IEMedPatientMedications[]>> {
    return api.get<IEMedPatientMedications[]>(
      "/Retool/EMedIntegration/PatientMedicationsByDate",
      { params: { date } }
    );
  },
};
